import React, { Component } from 'react';
import axios from "axios";

import api from '../../../api/';

import Create from "./Create.js"
import Edit from "./Edit.js"
import Delete from "./Delete.js"
import Detail from "./Detail.js"

import ParadigmaTable from "../../../components/ParadigmaTable/"



class CondicionesDePago extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "pk",
                    accessor: "pk",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Nombre",
                    id: "nombre",
                    accessor: d => d.nombre,
                    show: true,
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create:true,
                        permission: 'condicionesdepago_add',
                        component: Create,
                    },
                    {
                        edit:true,
                        permission: 'condicionesdepago_edit',
                        component: Edit,
                    },
                    {
                        detail: true,
                        permission: 'condicionesdepago_detail',
                        component: Detail,
                    },
                    {
                        edit:true,
                        permission: 'condicionesdepago_delete',
                        component: Delete,
                    }
                ]}

                apiUrl={api.proyectos.config.presupuesto.condiciones.list}
                columns={this.state.columns}
                exportUrl={api.proyectos.config.presupuesto.condiciones.export}
                title={"Monedas de Pago"}
                outerSort={[{"id":"nombre","desc":false}]}
            />
        );
    }
}

export default CondicionesDePago;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Presupuesto_Condiciones/Condiciones.js